import { API } from "@/lib/api";
import { FileXls, FileCsv } from "@phosphor-icons/react";

export default function ExportPage() {
  const token = localStorage.getItem("ecc_token");
  const download = (fmt) => {
    const url = `${API}/export/xlsx?format=${fmt}`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob())
      .then(b => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.download = `ecomkit_catalog.${fmt}`;
        a.click();
      });
  };

  return (
    <div data-testid="export-page" className="space-y-6 max-w-3xl min-w-0">
      <div>
        <div className="eyebrow mb-1">Export Center</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Take your catalog anywhere</h1>
        <p className="text-muted-foreground mt-2 text-sm">All products with platform status and image URLs included.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <button data-testid="export-xlsx" onClick={()=>download("xlsx")} className="card-base p-8 text-left hover:border-navy transition-colors">
          <div className="w-12 h-12 rounded-lg bg-brand-green/10 flex items-center justify-center mb-5">
            <FileXls size={26} weight="duotone" className="text-brand-green"/>
          </div>
          <div className="font-display font-semibold text-xl text-navy">Export as XLSX</div>
          <div className="text-sm text-muted-foreground mt-1">All products with platform status and images.</div>
        </button>
        <button data-testid="export-csv" onClick={()=>download("csv")} className="card-base p-8 text-left hover:border-navy transition-colors">
          <div className="w-12 h-12 rounded-lg bg-orange/10 flex items-center justify-center mb-5">
            <FileCsv size={26} weight="duotone" className="text-orange"/>
          </div>
          <div className="font-display font-semibold text-xl text-navy">Export as CSV</div>
          <div className="text-sm text-muted-foreground mt-1">Universal format for any platform or tool.</div>
        </button>
      </div>
    </div>
  );
}
